import { Component, OnInit } from '@angular/core';
import { EntityService } from '../../../entities/services/entity.service';
import { EntityModel } from '../../../entities/models/entity-model';
import { Subject } from 'rxjs/Subject';
import { ToolbarService } from '../../../layouts/toolbar/services/toolbar.service';
import { ActivatedRoute } from '@angular/router';
import { EntityFormService } from '../../../forms/form/services/entity-form.service';
import { AlertService } from '../../../alerts/services/alert.service';
import { LoaderService } from '../../../support/loading/loader.service';
import { ModalService } from '../../../modals/services/modal.service';
import { ToastService } from '../../../toast/services/toast.service';
import { trans } from '../../../localization/helpers';

@Component({
    selector: 'chassis-entities-create-page',
    templateUrl: './entity-edit.page.html',
    styleUrls: [ './entity-edit.page.scss' ],
    providers: [ EntityFormService, AlertService ]
})
export class EntityEditPage implements OnInit {

    public fieldSearch   = '';
    public entity: EntityModel;
    public elements      = [];
    public defaultFormId = null;

    protected entityLoader;
    protected fieldEditMode: string;

    protected entityReady: Subject<boolean> = new Subject();

    /**
     * Construct
     *
     * @param modalService
     * @param alertService
     * @param entityService
     * @param formService
     * @param loader
     */
    constructor(protected modalService: ModalService,
                protected alertService: AlertService,
                protected entityService: EntityService,
                protected formService: EntityFormService,
                protected loader: LoaderService,
                protected toastService: ToastService,
                protected toolbarService: ToolbarService,
                protected route: ActivatedRoute) {

        // create loader instance
        this.entityLoader = this.loader.create('entityLoader');

        // load available elements
        this.elements = this.entityService.getAvailableElements();
    }

    public ngOnInit(): void {

        this.entityService.one(parseInt(this.route.snapshot.params[ 'entity' ], 10)).subscribe(entity => {
            this.entity = entity;

            // get the default form id
            const form = this.entity.forms().find('default', true);

            if (form === undefined) {
                throw new Error('No default form was found for the `' + entity.name + '` entity');
            }

            this.defaultFormId = form.id;
        });


        this.createToolbar();

    }

    /**
     * Creates the toolbar
     *
     */
    public createToolbar() {
        this.toolbarService.add({
            name: 'add',
            text: trans('Add'),
            callback: () => {
                this.saveEntity();
            },
            loader: () => {
                return this.entityLoader.isLoading();

            }
        });
    }

    public saveEntity() {
        this.entityLoader.start();

        this.entity.save()
            .subscribe(entity => {
                this.toastService.successSaved();
            }, (error) => {
                this.toastService.error('api-error');
            }, () => {
                this.entityLoader.stop();
            });
    }

    /**
     * Add new field
     *
     * @param element
     */
    public addField(element) {
        const newField             = Object.assign({}, element);
        // newField.id                = UUID.UUID();
        newField.name              = '';
        newField.label             = {};
        newField.translatable      = false;
        newField.dynamic           = true;
        newField.validation        = [];
        newField.config            = {
            available_in_overview: false,
            show_in_overview: false
        };
        newField.roles_permissions = this.copyRolesPermissionsToField();

        const transformedField = this.entity.fieldsMeta().push(newField);

        this.editField(transformedField, null, null, () => {

            this.entity.fieldsMeta().forget('uid', transformedField.uid);
        });
    }

    /**
     * Edit field
     *
     * @param field
     */
    public editField(field, onSubmit: Function, onChange: Function, onClose: Function) {
        this.fieldEditMode = field.id;

        // create modal
        // this.modalService.create(CoreModule, FieldFormComponent, {type: 'slide-right', size: 'md'}, {
        //     field: field,
        //     onSubmit: () => {
        //         this.fieldEditMode = '';
        //
        //         // call the callback if set
        //         if (onSubmit) {
        //             onSubmit();
        //         }
        //     },
        //     onChange: (updatedField) => {
        //
        //         // call the callback if set
        //         if (onChange) {
        //             onChange(updatedField);
        //         }
        //     },
        //     onClose: () => {
        //         this.fieldEditMode = '';
        //
        //         // call the callback if set
        //         if (onClose) {
        //             onClose();
        //         }
        //     }
        // });
    }

    /**
     * Remove field from collection
     *
     * @param fieldId
     */
    public deleteField($event, field) {
        $event.stopPropagation();

        // show alert first
        // this.alertService.create('Are you sure you want to delete this field?', '', () => {
        //     this.entity.fieldsMeta().delete(field.name, 'name').subscribe(() => {
        //         this.toastService.successDeleted();
        //     });
        // });
    }

    /**
     * Get element by type from entity service
     *
     * @param type
     * @returns {{name: string, icon: string, type: string}}
     */
    public getElementByType(type) {
        return this.entityService.getElementByType(type);
    }

    /**
     * Copy entity roles and permissions to field
     *
     * @returns
     */
    private copyRolesPermissionsToField() {

        return this.entity.roles_permissions.map(rolePerm => {
            // lose reference
            rolePerm = Object.assign({}, rolePerm);

            rolePerm.permission = 'read-write';
            return rolePerm;
        });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/entities/edit/entity-edit.page.ts